<template>
  <Layout>
    <template #left>
      <PaymentOptions />
    </template>
    <template #right>
      <PaymentOverview />
    </template>
  </Layout>
</template>

<script
  lang="ts"
  setup
>
import Layout from '../Layout.vue';
import PaymentOptions from './options/index.vue';
import PaymentOverview from './overview/index.vue';
</script>
